import axios from 'axios';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://localhost:7001/api',
  headers: { 'Content-Type': 'application/json' },
});

// Token is injected by the auth interceptor set up in App.tsx
// This allows access to the React auth context from outside components
let tokenGetter: (() => Promise<string>) | null = null;

export function setTokenGetter(getter: () => Promise<string>) {
  tokenGetter = getter;
}

apiClient.interceptors.request.use(async (config) => {
  if (tokenGetter) {
    try {
      const token = await tokenGetter();
      config.headers.Authorization = `Bearer ${token}`;
    } catch {
      // Token expired — will get 401, handled by response interceptor
    }
  }
  return config;
});

export default apiClient;
